import React from "react";
import "./App.css";
import { AppRouter } from "./route";

function App() {
  return <AppRouter />;
}

export default App;
